interface SDGBadgeProps {
  number: number;
  title: string;
  description: string;
}

const sdgColors: Record<number, { bg: string; text: string; border: string }> = {
  7: { bg: "bg-gradient-to-br from-[#FCC30B] to-[#FFDF5D]", text: "text-black", border: "border-[#FCC30B]/30" },
  9: { bg: "bg-gradient-to-br from-[#FD6925] to-[#FF8F5E]", text: "text-white", border: "border-[#FD6925]/30" },
  11: { bg: "bg-gradient-to-br from-[#FD9D24] to-[#FFBE5E]", text: "text-black", border: "border-[#FD9D24]/30" },
  12: { bg: "bg-gradient-to-br from-[#BF8B2E] to-[#D4A84B]", text: "text-white", border: "border-[#BF8B2E]/30" },
  13: { bg: "bg-gradient-to-br from-[#3F7E44] to-[#5A9E60]", text: "text-white", border: "border-[#3F7E44]/30" },
};

const SDGBadge = ({ number, title, description }: SDGBadgeProps) => {
  const colors = sdgColors[number] || { bg: "bg-primary", text: "text-primary-foreground", border: "border-primary/30" };

  return (
    <div className={`group p-5 rounded-2xl bg-card/80 backdrop-blur-sm border ${colors.border} hover:border-opacity-60 transition-all duration-500 text-center hover:-translate-y-1 hover:shadow-xl overflow-hidden relative`}>
      {/* Animated glow */}
      <div className={`absolute -top-10 -right-10 w-24 h-24 rounded-full ${colors.bg} blur-3xl opacity-20 group-hover:opacity-40 transition-opacity`} />
      
      <div className="relative z-10">
        <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl ${colors.bg} flex items-center justify-center text-2xl font-bold ${colors.text} shadow-lg transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}>
          {number}
        </div>
        <h3 className="font-semibold text-foreground text-sm mb-2 line-clamp-2">{title}</h3>
        <p className="text-xs text-muted-foreground line-clamp-2">{description}</p>
      </div>
    </div>
  );
};

export default SDGBadge;
